import { gql } from '@apollo/client';

export const GET_PIPEDRIVE_STAGES = gql`
  query GetPipedriveStages {
    pipedriveStages {
      id
      name
      pipelineId
      pipelineName
      orderNr
      dealProbability
      rottenFlag
      rottenDays
    }
  }
`;